import { render, staticRenderFns } from "./CardServeRank.vue?vue&type=template&id=fa74b104&scoped=true&"
import script from "./CardServeRank.vue?vue&type=script&lang=js&"
export * from "./CardServeRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa74b104",
  null
  
)

export default component.exports